module.exports = {
    controllerItems: [
        { value: 'client', text: 'Пользователь' },
        { value: 'secretClient', text: 'Тайный клиент' },
        { value: 'variable', text: 'Переменные' },
        { value: 'message', text: 'Сообщения' },
        { value: 'mailing', text: 'Рассылки' },
        { value: 'cardList', text: 'Группы карточек' },
        { value: 'panelClientEdit', text: 'Панель управления пользователем' },
        { value: 'panelClientEditStatic', text: 'Группа кнопок по редактированию переменных' },
        { value: 'shop', text: 'Магазин' },
        { value: 'trade', text: 'Трейдер' }
    ],
    buttonTypes: [
        { value: 'text', text: 'Текстовая кнопка' },
        { value: 'url', text: 'Ссылка' },
        { value: 'action', text: 'Действие' },
        { value: 'contact', text: 'Отправить номер телефона (Telegram)' },
        { value: 'location', text: 'Отправить текущие координаты (Telegram)' }
    ],
    actions: {
        client:
            [
                { value: 'searchById', text: 'Найти пользователя по id' },
                { value: 'searchByUsername', text: 'Найти пользователя по нику' },
                { value: 'reportPointsAllTime', text: 'Отчет по баллам за все время' },
                { value: 'pay', text: 'Оплатить товар баллами' }
            ],
        secretClient:
            [
                { value: 'all', text: 'Список всех блоков заданий' },
                { value: 'createTask', text: 'Создать блок с заданиями' },
                { value: 'voteAll', text: 'Список всех опросов' },
                { value: 'createVote', text: 'Создать опрос' },
                { value: 'beginVote', text: 'Начать активный опрос' },
                { value: 'secretClientSubscribe', text: 'Подписка на тайного клиента' }
            ],
        variable:
            [],
        mailing:
            [
                { value: 'new', text: 'Создать' },
                { value: 'work', text: 'В работе' },
                { value: 'end', text: 'Завершенные' }
            ],
        cardList:
            [
                { value: 'all', text: 'Все группы' }
            ],
        message:
            [
                { value: 'sendMessage', text: 'Отправить выбранное сообщение' },
                { value: 'sendMessageN', text: 'Отправить выбранное сообщение с оповещением о доставке' },
                { value: 'editMessage', text: 'Изменить сообщение на выбранное' },
                { value: 'editMessageReply', text: 'Изменить клавиатуру' },
                { value: 'resetReplyMessage', text: 'Сбросить клавиатуру до начального состояния' }
            ],
        panelClientEdit:
            [
                { value: 'panelEditVariables', text: 'Редактирование переменных' },
                { value: 'sendNextText', text: 'Отправить следующий текст' }
            ],
        panelClientEditStatic:
            [
                { value: 'allEditVariablesClient', text: 'Кнопки переменная/значение/кнопка редактирования' }
            ],
        shop:
            [
                { value: 'catalog', text: 'Вывести каталог' },
                { value: 'basket', text: 'Зайти в корзину' },
                { value: 'orders', text: 'Мои заказы' },
                { value: 'client_box', text: 'Личный кабинет' },
                { value: 'help', text: 'Помощь' },
                { value: 'news', text: 'Подписка на новости' },
                { value: 'createEmptyOrder', text: 'Создать пустой заказ' },
                { value: 'scheduleToday', text: 'Расписание на сегодня' },
                { value: 'scheduleTodayByAddress', text: 'Расписание на сегодня группе доставке' },
                { value: 'scheduleTwoDay', text: 'Расписание на 2 дня' },
                { value: 'clientOrders', text: 'Заказы клиента' },
                { value: 'scheduleEditList', text: 'Редактирование часов в расписании' },
                { value: 'catalogEdit', text: 'Редактирование каталога' },
                { value: 'catalogPointsPay', text: 'Оплатить товар баллами' },
                { value: 'discountCard', text: 'Дисконтная карта' },
                { value: 'selectDelivery', text: 'Имитация выбора адреса' }
            ],
        trade:
            [
                { value: 'myBots', text: 'Показать всех ботов' },
                { value: 'newBot', text: 'Добавить нового бота' },
                { value: 'clientBox', text: 'Личный кабинет' },
                { value: 'marginSolve', text: 'Рассчитать маржу' }
            ]
    }
}
